import { c as _c } from "react/compiler-runtime";
import { useConnectedPaymentIntegrations } from 'modules/profile/payment-gateways/hooks/use-connected-payment-integrations';
import { cashOnDeliveryUpdate } from 'modules/profile/payment-gateways/integrations/cash-on-delivery/api';
import { CashOnDeliveryEditIntegrationInterface, CashOnDeliveryErrorsIntegrationInterface } from 'modules/profile/payment-gateways/integrations/cash-on-delivery/types';
import React, { useState } from 'react';
import EditModal from 'shared/components/edit-modal';
import FormTextarea from 'shared/components/form-textarea';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { fetchWithErrors } from 'shared/utils/fetch-with-errors';
interface CashOnDeliveryEditModalProps {
  instructions: string | null;
}
const defaultErrors: CashOnDeliveryErrorsIntegrationInterface = {
  instructions: ''
};
const CashOnDeliveryEditModal = t0 => {
  const $ = _c(26);
  const {
    instructions
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [opened, setOpened] = useState(false);
  const [errors, setErrors] = useState(defaultErrors);
  const t1 = instructions || "";
  let t2;
  if ($[0] !== t1) {
    t2 = {
      instructions: t1
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const [tempState, setTempState] = useState(t2);
  const {
    mutatePaymentIntegrations
  } = useConnectedPaymentIntegrations();
  let t3;
  if ($[2] !== mutatePaymentIntegrations) {
    t3 = async data => {
      await fetchWithErrors(async () => {
        await cashOnDeliveryUpdate(data);
        await mutatePaymentIntegrations();
      }, setErrors);
    };
    $[2] = mutatePaymentIntegrations;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const onUpdate = t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setOpened(true);
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t) {
    t5 = t("dashboard.settings.payment-gateways.edit_cash_on_delivery_instructions");
    $[5] = t;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t5) {
    t6 = <button className="primary-link" onClick={t4}>{t5}</button>;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t) {
    t7 = t("dashboard.settings.payment-gateways.edit_cash_on_delivery_instructions");
    $[9] = t;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => {
      setOpened(false);
    };
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== errors || $[13] !== t) {
    t9 = [{
      field: "instructions",
      onRender: (value, onChange, _, __, isPreFetching) => <FormTextarea key="cash-on-delivery-edit-instructions" label={t("dashboard.settings.payment-gateways.instructions_title")} isLoading={isPreFetching} onChange={e => {
        setTempState(prev => ({
          ...prev,
          instructions: e.target.value
        }));
        onChange(e.target.value);
      }} value={value || ""} error={errors.instructions} className="min-h-[126px]" />
    }];
    $[12] = errors;
    $[13] = t;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== onUpdate) {
    t10 = data_0 => onUpdate(data_0);
    $[15] = onUpdate;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== opened || $[18] !== t10 || $[19] !== t7 || $[20] !== t9 || $[21] !== tempState) {
    t11 = <EditModal fullCaption={t7} opened={opened} onClose={t8} instance={tempState} editable={t9} onEdit={t10} />;
    $[17] = opened;
    $[18] = t10;
    $[19] = t7;
    $[20] = t9;
    $[21] = tempState;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t11 || $[24] !== t6) {
    t12 = <>{t6}{t11}</>;
    $[23] = t11;
    $[24] = t6;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  return t12;
};
export default CashOnDeliveryEditModal;